import React from 'react'
import { withIcon } from '../../withIcon'

function PlayTriangleIcon (props) {
  const {
    size = '10px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 10 12" fill="none">
      <path d="M10 6L0 12V0L10 6Z" fill={color} />
    </svg>
  )
}

export default withIcon(PlayTriangleIcon)
